import { printConsoleError } from '../helper';

export const ArrayUtil = {
  getLength: (inputArray: any[]) => {
    if (!Array.isArray(inputArray)) {
      printConsoleError('ArrayUtil - getLength', { inputArray });
    }

    return Array.isArray(inputArray) ? inputArray.length : 0;
  },
  isEmpty: (inputArray: any[]) => {
    if (!Array.isArray(inputArray)) {
      printConsoleError('ArrayUtil - isEmpty', { inputArray });
    }

    return Array.isArray(inputArray) ? inputArray.length === 0 : true;
  },
};
